import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useRouteMatch, useHistory} from 'react-router';
import Modal from 'react-modal';
import {Formik, Form} from 'formik';
import FieldInput from '../../../../../common/components/FieldInput';
import AnimatedUploadingFilePopUp
  from '../../../../../common/components/AnimatedUploadingFilePopUp';
import {checkRequiredValues} from '../../../../../common/utils/form/checkRequiredValues';
import {checkEmailIsValid} from '../../../../../common/utils/form/checkEmailIsValid';
import {pathnames as P} from '../../../../../common/constants/pathnames';
import {errors as E} from '../../../../../common/constants/errors';
import styles from './styles.module.scss';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#root');

const ModalSendPDFDraft = ({
                             buttonClassName,
                             modalClassName,
                             overlayClassName,
                             sendPDFDraft,
                             showGlobalErrorMessage
                           }) => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [calling, setCalling] = useState(false);
  const {params: {shumaId}, url} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);

  const handleOpenModal = e => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(true);
  };

  const handleCloseModal = e => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(false);
  };

  const initialValues = {email: ''};

  const validate = values => {
    const errors = checkRequiredValues(values, {});
    if (!checkEmailIsValid(values.email)) errors.email = E.INVALID_EMAIL;
    return errors
  };

  const handleSubmit = values => {
    Promise.resolve()
      .then(() => setCalling(true))
      .then(() => sendPDFDraft({email: values.email, shumaId}))
      .then(() => showGlobalErrorMessage('טיוטה נשלחה בהצלחה', () => {history.push(url)}))
      .catch(error => showGlobalErrorMessage(error.message))
      .finally(() => setCalling(false))
  };

  return (
    <>
      <div
        className={`${styles.buttonPreview} ${buttonClassName}`}
        onClick={handleOpenModal}
      >
        <span>שליחת טיוטה</span>
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={handleCloseModal}
        className={`${styles.modal} ${styles['rtl']} ${modalClassName}`}
        overlayClassName={`${styles.overlay} ${overlayClassName}`}
      >
        <div className={styles.modalContentContainer}>
          <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={handleSubmit}
            enableReinitialize={true}
            validateOnChange={true}
            validateOnBlur={false}
          >
            {({values}) => (
              <Form>
                <div className={styles.form}>
                  <FieldInput
                    fieldId="email"
                    type={'text'}
                    value={values.email}
                    label="כתובת אימייל"
                  />
                </div>
                <div className={styles.modalButtons}>
                  <button
                    type="submit"
                    className={styles.buttonSubmit}
                  >
                    <span>שליחה</span>
                  </button>
                  <button
                    type="button"
                    className={styles.buttonCancel}
                    onClick={handleCloseModal}
                  >
                    <span>ביטול</span>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      <AnimatedUploadingFilePopUp
        show={calling}
        duration={50}
        percentsPerSec={2}
        type={'linear'}
      />
    </>
  );
};

ModalSendPDFDraft.propTypes = {
  buttonClassName: PropTypes.string,
  modalClassName: PropTypes.string,
  overlayClassName: PropTypes.string,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};

export default ModalSendPDFDraft;
